import { Link } from "./lib/router.tsx";

export const CONTACT_PATH = "/contact";
export const SUPPORT_EMAIL = "support@futurestaxreport.com";

export function Contact() {
  return (
    <div className="shell guide contact-page">
      <section className="page-head">
        <p className="crumbs">
          <Link href="/">Home</Link> / Contact
        </p>
        <h1>Contact us</h1>
        <p className="lede">
          Questions about a calculator, your tax report or a purchase? Email{" "}
          <a href={`mailto:${SUPPORT_EMAIL}`}>{SUPPORT_EMAIL}</a> and a person will read it and write back.
        </p>
      </section>
      <section className="card guide-section">
        <h2 className="card-title">Before you write</h2>
        <ul className="plain-list">
          <li>
            <strong>About a purchase:</strong> include the email address you used at checkout, so we can find it.
          </li>
          <li>
            <strong>Please don't send</strong> tax forms, Social Security numbers or passwords. Your tax report stays in your browser, and we never
            need them to help you.
          </li>
          <li>
            <strong>About a number:</strong> tell us which page and what you entered. We can explain how the site worked it out, but we can't give
            personal tax advice. For that, a CPA or enrolled agent is the right person.
          </li>
        </ul>
      </section>
    </div>
  );
}
